import { useMemo } from "react";

import { PLATFORM_BREAKDOWN_ID } from "../constants";
import {
  makeAdKeyDimension,
  makeNameDimension,
  makeStatusDimension,
} from "../dimensions";
import { type TableState } from "../types";

import { useBreakdownDimensions } from "./use-breakdown-dimensions";

export const useTableStateDimensions = (tableState: TableState) => {
  const breakdownDimensions = useBreakdownDimensions();

  return useMemo(() => {
    const adKeyDimension = makeAdKeyDimension();
    const nameDimension = makeNameDimension();
    const statusDimension = makeStatusDimension();

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const breakdownDimension = breakdownDimensions.find(
      (d) => d.id === tableState.selectedBreakdownId,
    )!;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const platformDimension = breakdownDimensions.find(
      (d) => d.id === PLATFORM_BREAKDOWN_ID,
    )!;

    const dimensionsToSelect = [];
    let nameColumn = null;
    let idColumn = null;

    if (tableState.selectedTab === "breakdown") {
      dimensionsToSelect.push(breakdownDimension);
      idColumn = breakdownDimension;
      nameColumn = breakdownDimension;
    } else {
      dimensionsToSelect.push(adKeyDimension, platformDimension, nameDimension);

      if (tableState.selectedMetricIds.includes("dimension:status")) {
        dimensionsToSelect.push(statusDimension);
      }

      if (
        breakdownDimension.id !== platformDimension.id &&
        breakdownDimension.id !== "date"
      ) {
        dimensionsToSelect.push(breakdownDimension);
      }

      idColumn = adKeyDimension;
      nameColumn = nameDimension;
    }

    return {
      breakdownDimension,
      platformDimension,
      statusDimension,
      dimensionsToSelect,
      idColumn,
      nameColumn,
    };
  }, [
    breakdownDimensions,
    tableState.selectedBreakdownId,
    tableState.selectedTab,
    tableState.selectedMetricIds,
  ]);
};
